import { Box, ChakraProps, Flex, useColorModeValue } from '@chakra-ui/react';
import { LinkProps } from '@tanstack/react-router';

export interface SidebarNavGroupTitleProps extends LinkProps {
  chakraProps?: ChakraProps;
  isSidebarCollapsed?: boolean;
  /** Suppress the top margin when this is the first group, so it hugs the top. */
  isFirst?: boolean;
  children: React.ReactNode;
}

export const SidebarNavGroupTitle = ({
  children,
  chakraProps,
  isSidebarCollapsed,
  isFirst,
}: SidebarNavGroupTitleProps) => {
  const textColor = useColorModeValue('gray.400', 'gray.300');

  return (
    <Box mt={isFirst ? '0' : '4'} w="full" overflow="hidden" cursor="default">
      <Flex
        align="center"
        px="3"
        h="7"
        mt={isFirst ? '0' : '4'}
        role="group"
        color={textColor}
        fontSize="xs"
        transition="0.7s cubic-bezier(0.22, 0.61, 0.36, 1)"
        opacity={isSidebarCollapsed ? 0 : 1}
        {...chakraProps}
      >
        {children}
      </Flex>
    </Box>
  );
};
